import { Drawer, SimpleToolbar, Loader, Toast } from "../../../components";
import {
  Grid,
  Container,
  makeStyles,
  Box,
  TablePagination,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  Typography,
  IconButton,
  Hidden,
  Button,
  Icon,
  CircularProgress,
} from "@material-ui/core";
import { useDrawer } from "../../../hooks";
import { AuthContext } from "../../../context";
import { useContext, useEffect, useState } from "react";
import { laboratoryServices } from "../../../services";
import { capitalizeFirstLetterArray } from "../../../helpers";
import { CustomTable } from "../../../components/custom-table";
import KeyboardArrowDownRoundedIcon from "@material-ui/icons/KeyboardArrowDownRounded";
import Row from "../../../components/zonifyDoctorTableRow";
import LinkButton from "../../../components/link-button";
import PostAddOutlinedIcon from "@material-ui/icons/PostAddOutlined";
export default function DoctorZonesScreen() {
  const classes = useStyles();
  const { authState, signOut } = useContext(AuthContext);
  const { isOpen, setIsOpen } = useDrawer();
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [doctorLoading, setDoctorLoading] = useState(null);
  // const [isDownloading, setIsDownloading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [doctors, setDoctors] = useState([]);
  const [zones, setZones] = useState([]);
  const getDoctors = async () => {
    try {
      setLoading(true);
      const { status, response } =
        await laboratoryServices.getAssociatedUsersByLab({
          getOptions: {
            roles: ["doctors"],
            ascending: true,
            limit,
            page,
          },
          laboratoryId: authState.user.laboratory._id,
          token: authState.token,
        });
      // console.log(response.response);

      setLoading(false);
      if (status === 200) {
        setDoctors(response.response.data);
        setLimit(response.response.limit);
        setCount(response.response.total);
        setPage(response.response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getDoctors();
  }, [page, limit]);

  async function getVisitingZones() {
    // setLoading(true);

    laboratoryServices
      .getVisitingZones({
        laboratoryId: authState.user.laboratory._id,
        token: authState.token,
      })
      .then((res) => {
        if (res.status === 200) {
          // console.log("zones database", res.response.response);

          setZones(
            res.response.response.map((z) => ({ _id: z._id, name: z.name })) ||
              []
          );
        }
      })
      .catch((e) => console.error(e));
    // .finally(() => setLoading(false));
  }

  useEffect(() => {
    getVisitingZones();
  }, []);

  const handleSubmit = ({ _id, selectedZones }) => {
    setDoctorLoading(_id);
    laboratoryServices
      .updateDoctorZones({
        updatedDoctorInfo: {
          doctorId: _id,
          laboratoryId: authState.user.laboratory._id,
          zones: selectedZones.map((z) => z._id),
        },
        token: authState.token,
      })
      .then((res) => {
        setToast(true);
        // console.log(res);

        if (res.status === 200) {
          setToastMessage(res.response.response.message);
          setDoctors((prev) =>
            prev.map((doc) =>
              doc._id === _id
                ? {
                    ...doc,
                    zones: selectedZones.map((z) => ({ visitingZoneInfo: z })),
                  }
                : doc
            )
          );
        } else setToastMessage(res.response.message);
      })
      .catch((e) => console.error(e))
      .finally(() => setDoctorLoading(null));
  };

  // const handleDownload = async () => {
  //   try {
  //     setIsDownloading(true);
  //     const { status, response } = await laboratoryServices.exportDoctors({
  //       token: authState.user.token,
  //     });
  //     setLoading(false);
  //     if (status === 200) {
  //       var blob = new Blob([response], {
  //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       });
  //       var link = document.createElement("a");
  //       link.href = window.URL.createObjectURL(blob);
  //       link.download = "usuarios.xlsx";
  //       link.click();
  //       window.URL.revokeObjectURL(link.href);
  //     } else if (status === 401) {
  //       signOut();
  //     }
  //   } catch (error) {
  //     setToast(true)
  //     setToastMessage("Ha ocurrido un error, intente en un momento.")
  //   } finally {
  //     setIsDownloading(false);
  //   }
  // };
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        {loading && <Loader loading={true} />}
        <Toast
          open={toast}
          message={toastMessage}
          close={() => setToast(false)}
        />
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={authState.user.laboratory}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              noSearchBar
            />
          </Container>
          <Container maxWidth={"md"} component={"main"}>
            <Box display={"flex"} justifyContent={"end"} mt={2}>
              {/* <Button
                color="secondary"
                variant="contained"
                style={{ textTransform: "none" }}
                onClick={handleDownload}
                disabled={isDownloading}
              >
                {isDownloading && (
                  <CircularProgress
                    color="secondary"
                    size={24}
                    style={{ position: "absolute" }}
                  />
                )}
                <Typography
                  component={"span"}
                  style={{ opacity: isDownloading ? 0 : 1 }}
                >
                  Zonificar por excel
                </Typography>
              </Button> */}
              <LinkButton
                variant="contained"
                color="secondary"
                to={{
                  pathname: "/zones/doctors/zonify",
                }}
              >
                <Typography
                  component={"span"}
                  style={{ display: "flex", gap: 4, alignItems: "center" }}
                >
                  <PostAddOutlinedIcon fontSize="small" />
                  Asignar zonas por excel
                </Typography>
              </LinkButton>
            </Box>
            <CustomTable
              propsTable={{
                id: "DoctorsZoneTable",
                style: { tableLayout: "fixed" },
                boxProps: { style: { height: "65vh" } },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell component="th" style={{ width: "5%" }} />
                  <TableCell component="th" style={{ width: "20%" }}>
                    Nombre
                  </TableCell>
                  <TableCell component="th" style={{ width: "20%" }}>
                    Apellido
                  </TableCell>
                  <TableCell component="th" style={{ width: "20%" }}>
                    Rut
                  </TableCell>
                  <TableCell component="th" style={{ width: "35%" }}>
                    Correo
                  </TableCell>
                </TableRow>
              </TableHead>
              <Hidden smUp>
                <TableHead style={{ display: "table-header-group" }}>
                  <TableRow>
                    <TableCell style={{ padding: "8px 20px" }}>
                      <Box display={"flex"} style={{ gap: 14 }}>
                        <Icon style={{ alignSelf: "center" }}>
                          <KeyboardArrowDownRoundedIcon />
                        </Icon>

                        <Box style={{ textAlign: "start" }}>
                          <Typography
                            style={{
                              fontWeight: "bold",
                              overflowWrap: "anywhere",
                            }}
                          >
                            Nombre y Apellido
                          </Typography>
                          <Typography
                            style={{
                              fontSize: "0.9rem",
                              overflowWrap: "anywhere",
                            }}
                          >
                            Rut
                          </Typography>
                          <Typography
                            style={{
                              fontSize: "0.9rem",
                              overflowWrap: "anywhere",
                            }}
                          >
                            Correo
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Hidden>
              <TableBody>
                {!doctors?.length && !loading && (
                  <TableRow>
                    <TableCell style={{ textAlign: "center" }} colSpan={100}>
                      No hay datos que correspondan con su búsqueda
                    </TableCell>
                  </TableRow>
                )}
                {doctors?.map((doctor) => {
                  const { _id, name, lastName, rut, email } = doctor;
                  const hasZones = doctor.zones ? true : false;
                  const doctorZones = hasZones
                    ? doctor.zones?.map((z) => ({
                        _id: z.visitingZoneInfo._id,
                        name: z.visitingZoneInfo.name,
                      }))
                    : [];
                  return (
                    <Row
                      key={_id}
                      loading={doctorLoading === _id}
                      name={capitalizeFirstLetterArray(name)}
                      lastName={capitalizeFirstLetterArray(lastName)}
                      rut={rut}
                      email={email}
                      zones={doctorZones}
                      options={zones}
                      onSubmit={(selectedZones) =>
                        handleSubmit({ _id, selectedZones })
                      }
                    />
                  );
                })}
              </TableBody>
            </CustomTable>
            <Box display="flex" justifyContent={"end"}>
              <TablePagination
                labelRowsPerPage="Cant."
                component="div"
                count={count}
                onRowsPerPageChange={(e) => {
                  setLimit(e.target.value);
                  setPage(1);
                }}
                onPageChange={(e, page) => setPage(page + 1)}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                className={classes.pagination}
              />
            </Box>
          </Container>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    flex: 1,
    minHeight: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  no_results: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(2),
    backgroundColor: `hsl(from ${theme.palette.primary.main} h s calc(l + 66))`,
    borderRadius: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  pagination: {
    "& .MuiTablePagination-toolbar": {
      flexWrap: "wrap",
      justifyContent: "center",
      padding: 0,
    },
  },
}));
